import UAParser from 'ua-parser-js'

import type { BrowserFingerprint, SessionId } from '@web-app/lib/ironSession'

// The UA never changes within a page lifetime; parse it once.
let cachedBrowserParser: UAParser | null = null
export const browserParser = (): UAParser => {
  cachedBrowserParser ??= new UAParser(window.navigator.userAgent)
  return cachedBrowserParser
}

type ClientInfoHeadersArgs = {
  uaParser: UAParser
  browserFingerprint?: BrowserFingerprint
  sessionId?: SessionId
  mcid?: string
  currentUrl?: string
  userAgent?: string
  wafToken?: string
  gaClientId?: string
  gaSessionId?: string
}

export const buildClientInfoHeaders = ({
  uaParser,
  browserFingerprint,
  sessionId,
  mcid,
  currentUrl,
  userAgent,
  wafToken,
  gaClientId,
  gaSessionId,
}: ClientInfoHeadersArgs) => {
  const browser = uaParser.getBrowser()
  const device = uaParser.getDevice()
  const os = uaParser.getOS()

  const deviceModel = device.model?.toLowerCase() || ''
  const deviceVendor = device.vendor?.toLowerCase() || ''

  return {
    ...(wafToken ? { 'x-aws-waf-token': wafToken } : {}),
    ...(browserFingerprint ? { 'X-Client-Udid': browserFingerprint } : {}),
    ...(userAgent ? { 'User-Agent': userAgent } : {}),
    ...(currentUrl ? { 'X-Current-Url': currentUrl } : {}),
    ...(sessionId ? { 'X-Session-Id': sessionId } : {}),
    // So the backend can address its own GA4 events to this browser and visit.
    ...(gaClientId ? { 'X-Ga-Client-Id': gaClientId } : {}),
    ...(gaSessionId ? { 'X-Ga-Session-Id': gaSessionId } : {}),
    ...(mcid ? { 'X-Mcid': mcid } : {}),
    'X-Client-Os': os.name?.toLowerCase() || 'unknown',
    'X-Client-Os-Version': os.version?.toLowerCase() || 'unknown',
    'X-Client-Browser': browser.name || 'unknown',
    'X-Client-Browser-Version': browser.version || 'unknown',
    'X-Client-Hardware':
      [deviceVendor, deviceModel].filter(Boolean).join(' ') || '',
    'X-Client-Platform': 'web',
    'X-Client-App': process.env.NEXT_PUBLIC_ANALYTICS_APP_ID || 'unknown',
    'X-Client-Build': '1.0',
  }
}
